type fields = {
  label: string;
  path: string;
};

type tableFields = {
    name: string;
    tension: string;
    speed: string;
    payout: string;
};




export const c_year = "Seapath.$INGGA.year";
export const c_month = "Seapath.$INGGA.month";
export const c_day = "Seapath.$INGGA.day";
export const c_time = "Seapath.$INGGA.time";

export const c_latitude = "Seapath.$INGGA.latitude";
export const c_longitude = "Seapath.$INGGA.longitude";
export const c_heading = "Gyro.$HEHDT.heading";
export const c_speed_over_ground = "Seapath.$INGGA.speed_over_ground";

export const c_primary_depth = "EA600.$SDDTT.depth";
export const c_secondary_depth = "EA600.$SDDTT.depth";


export const c_MeteoDataFields: fields[] = [
  { label: "Water Temperature:", path: `SBE38.$SBE38.temperature` },
  { label: "Air Temperature:", path: `KNMI Weather.$KNMIP.Air Temperature` },
  { label: "True Wind Speed:", path: `KNMI Weather.$KNMIP.truespeed` },
  { label: "True Wind Direction:", path: `KNMI Weather.$KNMIP.truedir` },
  { label: "Air Pressure:", path: `KNMI Weather.$KNMIP.Air Pressure` },
]

export const c_AquaFlowFields: fields[] = [
  { label: "Temperature:", path: `SBE38.$SBE38.temperature` },
  { label: "Conductivity:", path: `SBE45.$SBE45.conductivity` },
  { label: "Salinity:", path: `SBE45.$SBE45.salinity` },
  { label: "Sound Speed:", path: `SBE45.$SBE45.sound_velocity` },
  { label: "CO2:", path: `pCO2.$pCO2.CO2` },
  { label: "H2O:", path: `pCO2.$pCO2.H2O` },

]

export const c_WinchDataFields: tableFields[] = [
  { name: 'CTD winch', tension: `Winch.$WINCH.ctd_tension`, speed: `Winch.$WINCH.ctd_speed`, payout: `Winch.$WINCH.ctd_payout` },
  { name: 'Fiber winch', tension: `Winch.$WINCH.fiber_tension`, speed: `Winch.$WINCH.fiber_speed`, payout: `Winch.$WINCH.fiber_payout` },
  { name: 'Towing winch', tension: `Winch.$WINCH.towing_tension`, speed: `Winch.$WINCH.towing_speed`, payout: `Winch.$WINCH.towing_payout` },
  { name: 'Movable winch', tension: `Winch.$WINCH.movable_tension`, speed: `Winch.$WINCH.movable_speed`, payout: `Winch.$WINCH.movable_payout` },
  { name: 'Corer winch', tension: `Winch.$WINCH.corer_tension`, speed: `Winch.$WINCH.corer_speed`, payout: `Winch.$WINCH.corer_payout` }
]

